export default __webpack_public_path__ + "static/media/alert-triangle.3cabd179.svg";